"use client";

import { useEffect } from "react";

import api from "@/api";
import { PostResponseType } from "@/types/post";

function PostViewCounter({ postId }: { postId: PostResponseType["id"] }) {
  useEffect(() => {
    api.post.addView(postId);
  });

  return <></>;
}

export default PostViewCounter;
